import styled from 'styled-components'

const Container = styled.div`
  font-size: 12px;
  line-height: 18px;
  margin: 10px 0px 10px 33px;
  padding: 4px 4px 4px 0px;
`

const PrimaryMessage = styled.strong`
  display: block;
  float: left;
  line-height: 12px;
  height: 13px;
  margin: 3px 6px 0 0;
  padding-right: 6px;
  border-right: 1px solid black;

  &::before {
    content: '';
    width: 18px;
    height: 18px;
    display: block;
    float: left;
    margin: -3px 3px 0 0;
    background: url('//documents.4rgos.it/v1/static/click-and-collect-border');
    background-size: cover;
  }
`

export { Container, PrimaryMessage }
